// Function to show the modal
function showPopup() {
    const modal = document.getElementById('redirectModal');
    modal.style.display = 'block';
    modal.setAttribute('aria-hidden', 'false');
    document.querySelector('.modal-button.continue').focus(); // Set focus to the "Continue" button
}

// Function to hide the modal
function closePopup() {
    const modal = document.getElementById('redirectModal');
    modal.style.display = 'none';
    modal.setAttribute('aria-hidden', 'true');
}

// Function to handle redirection
function redirectToSite() {
    window.open('https://www.livewire.com/livewire-anti-social-social-club', '_blank');
    closePopup();
}
